import merge from 'lodash/merge';
import ClaimResponseItem from './ClaimResponseItem';
import DomainResource from './DomainResource';
import Reference from './types/Reference';
import CodeableConcept from './types/CodeableConcept';

export default class ClaimResponse extends DomainResource {
    static __className = 'ClaimResponse';

    __objectStructure = {
        status: String, // active | cancelled | draft | entered-in-error
        use: String, // claim | preauthorization | predetermination
        type: CodeableConcept,
        patient: Reference,
        created: String,
        insurer: Reference,
        request: Reference,
        outcome: String, // queued | complete | error | partial
        item: [ClaimResponseItem],
    };

    constructor(constructJson, className = 'ClaimResponse') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.populateCustomPropertiesFromJson(constructJson, []);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
